import type { Contractor } from '../contract.entities'

export function contractorHasCompleteContractSignData(contractor: Pick<Contractor, 'businessProfileData' | 'email'>, isTourOperatorContract = false): boolean {
	const data = contractor?.businessProfileData ?? {}
	const hasValue = (value: unknown) => String(value ?? '').trim().length > 0
	const requiredProfileFields: Array<keyof typeof data> = ['businessName', 'companyEmail', 'companyPhone', 'streetAddress', 'zipCode', 'city', 'country', 'invoiceRecipientName']
	const requiredBankingFields: Array<keyof typeof data> = ['accountHolder', 'iban', 'bic', 'creditInstitution']

	return requiredProfileFields.every(field => hasValue(data[field]))
		&& hasValue(contractor?.email)
		&& (data.dontHaveUidNumber === true || hasValue(data.uidNumber))
		&& ((isTourOperatorContract && data.dontHaveIban === true) || requiredBankingFields.every(field => hasValue(data[field])))
}
